import React, { useState } from 'react';
import { MainDialog } from '@components/dialog/main.dialog';
import { MainDialogTitle } from '@components/dialog/main.dialog.title';
import { CreditsFormProps } from '@screens/players/player.actions/credits/types/credits.form.props';
import { BonusForm } from '@screens/players/player.actions/credits/bonus.form';
import { StatsForm } from '@screens/players/player.actions/credits/stats.form';
import { CreditType } from '@screens/players/player.actions/credits/types/credit.type';
import { CreditTypeSelection } from '@screens/players/player.actions/credits/credit.type.selection';
import { ToggleDialogProps } from '@screens/players/player.actions/toggles/toggle.dialog.props';

const CreditsDialog = (props: ToggleDialogProps) => {
  const { open, player } = props;
  return (
    <MainDialog {...props}>
      <MainDialogTitle icon='redeem'>Credits & Bonuses</MainDialogTitle>
      <CreditsDialogContent onFinish={open.disable} player={player} />
    </MainDialog>
  );
};

const CreditsDialogContent = ({ onFinish, player }: CreditsFormProps) => {
  const [creditType, setCreditType] = useState<CreditType>(CreditType.none);

  return (
    <>
      {creditType === CreditType.none && <CreditTypeSelection onChange={setCreditType} />}
      {creditType === CreditType.stats && <StatsForm onFinish={onFinish} player={player} />}
      {creditType === CreditType.bonus && <BonusForm onFinish={onFinish} player={player} />}
    </>
  );
};

export default CreditsDialog;
